import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { mergeMap } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { Align } from '@progress/kendo-angular-popup';

import { DashboardService } from '../../dashboard/dashboard.service';
import { MainStoreState } from '../../../_store/mainStoreState';
import {
  hasSessionEdition,
  loadSessionEditionAction,
  releaseSessionEditionAction,
  selectAllSessions,
  takeSessionEditionAction,
} from '../../../_store/SessionStore/session.store';
import { getCurrentUser } from '../../../_store/AccountStore/account.store';
import { Account } from '../../../_models/Account';
import { MessageService } from '../../../_services/local/message.service';
import { SessionEdition } from '../../../_models/SessionEdition';
import { ConfirmService } from 'src/app/_services/local/confirm.service';

@Component({
  selector: 'app-session',
  templateUrl: './session.component.html',
  styleUrls: ['./session.component.scss'],
})
export class SessionComponent implements OnInit {
  @HostListener('keydown', ['$event'])
  public keydown(event: any): void {
    if (event.keyCode === 27) {
      this.toggle(false);
    }
  }

  @HostListener('document:click', ['$event'])
  public documentClick(event: any): void {
    if (!this.contains(event.target)) {
      this.toggle(false);
    }
  }

  @ViewChild('anchor') public anchor!: ElementRef;
  @ViewChild('popup', { read: ElementRef }) public popup!: ElementRef;

  private currentUser: Account | undefined;

  sessions?: (SessionEdition | undefined)[];
  anchorAlign: Align = {
    horizontal: 'left',
    vertical: 'bottom',
  };
  existsSessionForCurrentUser$ = new BehaviorSubject<SessionEdition | undefined>(undefined);
  show = false;

  constructor(
    private readonly store: Store<MainStoreState>,
    private readonly messageService: MessageService,
    private readonly confirmService: ConfirmService,
    private readonly dashboardService: DashboardService,
  ) {
    this.store.dispatch(loadSessionEditionAction());
  }

  ngOnInit(): void {
    this.store
      .select(getCurrentUser)
      .pipe(
        mergeMap((user) => {
          console.debug('current user', user);
          this.currentUser = user;
          return this.store.select(hasSessionEdition(this.currentUser));
        })
      )
      .subscribe((sessionEdition) => {
        console.debug('sessionEdition', sessionEdition);
        if (sessionEdition) {
          this.existsSessionForCurrentUser$.next(sessionEdition);
        } else {
          this.existsSessionForCurrentUser$.next(undefined);
          this.dashboardService.closeWidget('MapEditComponent');
        }
      });

    this.store.select(selectAllSessions).subscribe((sessions) => {
      this.sessions = sessions;
    });
  }

  toggle(show?: boolean): void {
    this.show = show !== undefined ? show : !this.show;
  }

  takeSession(): void {
    if (this.currentUser) {
      this.store.dispatch(takeSessionEditionAction());
    } else {
      this.messageService.info('Veuillez vous identifier.');
    }
  }

  forceTakeSession(): void {
    if (!this.sessions) {
      return;
    }
    this.confirmService
      .open(`Voulez-vous forcer la prise de session et déconnecter l'utilisateur `, this.sessions[0]?.userName)
      .then((res) => {
        if (res && this.currentUser) {
          this.store.dispatch(takeSessionEditionAction());
        }
      });
  }

  releaseSession(): void {
    this.store.dispatch(releaseSessionEditionAction());
  }

  private contains(target: any): boolean {
    return (
      (this.anchor && this.anchor.nativeElement && this.anchor.nativeElement.contains(target)) ||
      (this.popup ? this.popup.nativeElement.contains(target) : false)
    );
  }
}
